module.exports = __webpack_public_path__ + "img/XLS.02a38254.svg";